<app-accordion [multiple]="true">
  <app-accordion-item id="productSalesChannel" label="Políticas comerciais" icon="compass">
    <table class="w-full text-sm">
      <thead class="bg-neutral-50 dark:bg-neutral-800">
        <tr>
          <th class="text-left p-2">ID</th>
          <th class="text-left p-2">Nome</th>
          <th class="text-left p-2">País</th>
          <th class="text-left p-2">Culture info</th>
          <th class="text-left p-2">Moeda</th>
          <th class="text-left p-2">Ativo</th>
        </tr>
      </thead>
      <tbody>
        @for (row of stores; track row.storeId) {
        <tr class="border-t border-neutral-200 dark:border-neutral-700">
          <td class="p-2">{{ row.storeId }}</td>
          <td class="p-2">{{ row.name }}</td>
          <td class="p-2">{{ row.countryCode }}</td>
          <td class="p-2">{{ row.cultureInfo }}</td>
          <td class="p-2">{{ row.currencySymbol }}</td>
          <td class="p-2 font-semibold">{{ row.isActive ? 'Sim' : 'Não' }}</td>
        </tr>
        } @empty {
        <tr class="border-t border-neutral-200 dark:border-neutral-700">
          <td colspan="6">
            <p class="my-2 text-center">
              Este produto está disponível para todas as políticas comerciais.
            </p>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </app-accordion-item>
</app-accordion>
